<template>
  <v-app-bar
    app
    flat
    v-if="authenticated && $route.name !== 'Login'"
    color="rgba(255, 255, 255, 0.85)"
    class="app-topbar"
    height="64"
  >
    <div class="app-topbar__page">
      <span class="app-topbar__page-title">{{ $route.name }}</span>
    </div>
    <v-spacer></v-spacer>

    <v-menu offset-y transition="slide-y-transition" rounded="lg">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-bind="attrs" v-on="on" class="app-topbar__user">
          <v-avatar size="32" color="primary" class="mr-2">
            <span class="white--text text-caption font-weight-bold">
              {{ userInitials }}
            </span>
          </v-avatar>
          <span class="app-topbar__username hidden-sm-and-down">
            {{ user.username }}
          </span>
          <v-icon small right>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list dense nav>
        <v-list-item @click="logOut">
          <v-list-item-icon class="mr-3">
            <v-icon small color="error">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      device_ip_address: "",
      attendance_loading: false,
      employee_loading: false,
    };
  },
  created() {
    // check if exists

    if (this.devices.length <= 0) {
      this.get_devices();
    }
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      devices: "device/devices",
      user: "auth/user",
    }),
    userInitials() {
      const name = (this.user && this.user.username) || "";
      return name.slice(0, 2).toUpperCase();
    },
  },
  methods: {
    async logOut() {
      await this.signOut();

      this.$router.push("/");
    },
    async import_employees() {
      this.employee_loading = true;
      if (this.device_ip_address == "") {
        alert("Please select device first");
        this.employee_loading = false;
        return;
      }

      await this.download_users(this.device_ip_address).then(() => {
        alert("Successfully downloaded employees");
      });

      this.employee_loading = false;
    },

    ...mapActions({
      signOut: "auth/signout",
      download_users: "employee/download_users",
      download_attendances: "attendance/download_attendances",
      get_devices: "device/get_devices",
    }),
  },
};
</script>

<style scoped>
.app-topbar {
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #e2e8f0 !important;
}
.app-topbar__page-title {
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0f172a;
  text-transform: capitalize;
}
.app-topbar__user {
  border-radius: 12px;
}
.app-topbar__username {
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
}
</style>
